import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectTemplatesQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type GetProjectTemplatesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, workspace?: { __typename?: 'Workspace', id: string, projectTemplates?: { __typename?: 'ProjectTemplateConnection', nodes: Array<{ __typename?: 'ProjectTemplate', id: string, name: string, description?: string | null, image?: string | null, folderCount: number, customFieldCount: number, collectionCount: number }> } | null } | null } | null };


export const GetProjectTemplates = /*#__PURE__*/ gql`
    query GetProjectTemplates($workspaceId: ID!) {
  account(by: {workspaceId: $workspaceId}) {
    id
    workspace(workspaceId: $workspaceId) {
      id
      projectTemplates(page: {first: 20}) {
        nodes {
          id
          name
          description
          image
          folderCount
          customFieldCount
          collectionCount
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetProjectTemplatesQuery, GetProjectTemplatesQueryVariables>;

          

          export const useGetProjectTemplatesQuery = (options?:QueryHookOptions<GetProjectTemplatesQuery, GetProjectTemplatesQueryVariables>) => useQuery(GetProjectTemplates, options);

          

          export type GetProjectTemplatesQueryOptions = QueryHookOptions<GetProjectTemplatesQuery, GetProjectTemplatesQueryVariables>;

          

          export const useGetProjectTemplatesLazyQuery = (options?:LazyQueryHookOptions<GetProjectTemplatesQuery, GetProjectTemplatesQueryVariables>) => useLazyQuery(GetProjectTemplates, options);

          

          export type GetProjectTemplatesQueryResult = ReturnType<typeof useGetProjectTemplatesQuery>;

          
